import { Artist, Member } from "../../types/response/ISearchArtistResponse";
import baseUrl from "../../utils/baseUrl";
import getToken from "../../utils/getToken";

export async function getLikedArtistMembers(): Promise<{ likedArtistMembers: Record<string, Member[]>, likedArtists: Artist[] }> {
  const response = await fetch(`${baseUrl()}/api/v1/artists?liked_only=true`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${getToken()}`,
    },
  });
  const data = await response.json();
  const likedArtists: Artist[] = data.artists;
  const fetchLikedArtistMembers = likedArtists.map(async (artist: Artist) => {
    const member = artist.members.filter((member: Member) => member.isLiked);
    return [artist.artistId, member] as [string, Member[]];
  });
  
  const entries = await Promise.all(fetchLikedArtistMembers);
  const likedArtistMembers: Record<string, Member[]> = Object.fromEntries(entries);
    
  return {likedArtistMembers, likedArtists};
}